// @ts-strict-ignore
import styled from "styled-components";
import { PageContainer } from "components/layout/Layout";
import { mediaQuery } from "@hubble/web";

export const ConverterPageContainer = styled(PageContainer)`
  padding-top: 4.5rem;
  padding-bottom: 4.5rem;
  background-color: ${({ theme }) => theme.colorPalette.gray[50]};
  @media ${mediaQuery.mobileXsDown} {
    padding-top: 1.5rem;
    padding-bottom: 1rem;
  }
`;

export const ConverterPageContainerInner = styled.div`
  max-width: 1200px;
  margin: auto;
`;
export const OtherCardsContainer = styled.section`
  margin: 2.5rem auto;
`;

export const OtherCardsContentContainer = styled.div`
  display: grid;
  gap: 2.5rem;
  grid-template: repeat(2, 90px) repeat(3, 70px) repeat(1, 130px) / repeat(
      4,
      1fr
    );

  @media ${mediaQuery.mobileXsDown} {
    grid-template-rows: repeat(8, max-content);
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;
